import _extends from "@babel/runtime/helpers/extends";
import { ursaColors } from "@smartsheet/design-tokens";
import * as React from "react";
const rValue = {
  20: 7,
  24: 9
};
const paths = {
  25: {
    24: /*#__PURE__*/React.createElement("path", {
      d: "M20.2999 12.0697C20.2999 10.9706 20.2224 9.88222 19.8018 8.86675C19.3812 7.85129 18.7647 6.92861 17.9875 6.15141C17.2103 5.37421 16.2877 4.75769 15.2723 4.33708C14.2568 3.91646 13.1685 3.69997 12.0694 3.69997L12.0694 12.0697H20.2999Z",
      fill: "currentColor"
    }),
    20: /*#__PURE__*/React.createElement("path", {
      d: "M16.2999 10.0529C16.2999 9.21861 16.241 8.3925 15.9218 7.62173C15.6025 6.85095 15.1346 6.15061 14.5447 5.56068C13.9548 4.97076 13.2544 4.50281 12.4837 4.18354C11.7129 3.86427 10.8869 3.69995 10.0526 3.69995L10.0526 10.0529H16.2999Z",
      fill: "currentColor"
    })
  },
  50: {
    24: /*#__PURE__*/React.createElement("path", {
      d: "M 12.0694 3.7 C 13.1685 3.7 14.2568 3.9165 15.2723 4.3371 C 16.2877 4.7577 17.2103 5.3742 17.9875 6.1514 C 18.7647 6.9286 19.3812 7.8513 19.8018 8.8667 C 20.2224 9.8822 20.2999 10.9706 20.2999 12.0697 C 20.2999 12.7991 20.2224 13.8875 19.8018 14.9029 C 19.3812 15.9184 18.7647 16.8411 17.9875 17.6183 C 17 19 17 19 15 20 C 15 20 14 21 12 21 V 3.7 Z",
      fill: "currentColor"
    }),
    20: /*#__PURE__*/React.createElement("path", {
      d: "M9.947 16.195a6.247 6.247 0 1 0 0-12.495V16.195Z",
      fill: "currentColor"
    })
  },
  75: {
    24: /*#__PURE__*/React.createElement("path", {
      d: "M12.0694 3.7C13.1685 3.7 14.2568 3.9165 15.2723 4.3371C16.2877 4.7577 17.2103 5.3742 17.9875 6.1514C18.7647 6.9286 19.3812 7.8513 19.8018 8.8667C20.2224 9.8822 20.2999 10.9706 20.2999 12.0697C20.2999 12.7991 20.2224 13.8875 19.8018 14.9029C19.3812 15.9184 18.7647 16.8411 17.9875 17.6183C17 19 17 20 15 20C14 21 13 21 12 21C11 21 10 21 9 21C7 21 6 19 6 19C5 19 4 16 4 15C3.9162 13.8875 3.8387 12.7991 3.8387 12.0697C5 12 5 12 6 12C6 12 7 12 8 12C8 12 9 12 10 12C11 12 11 12 12 12Z",
      fill: "currentColor"
    }),
    20: /*#__PURE__*/React.createElement("path", {
      d: "M3.7 9.947A6.248 6.248 0 1 0 9.947 3.7v6.247H3.7Z",
      fill: "currentColor"
    })
  }
};
const SvgComponent = _ref => {
  let {
    fillColor = ursaColors.blue400,
    emptyFillColor = ursaColors.neutral00,
    size,
    value,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: `0 0 ${size} ${size}`
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: rValue[size],
    fill: value === 100 ? fillColor : emptyFillColor,
    stroke: fillColor,
    strokeWidth: "2"
  }), value === 25 ? paths[25][size] : value === 50 ? paths[50][size] : value === 75 ? paths[75][size] : ``);
};
export default SvgComponent;
//# sourceMappingURL=ProgressCircleSvg.js.map